import React, { useState } from 'react'
import styled from 'styled-components'

const noimg = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`

const LazyImg = ({ imgPath, alt, isAdult = false }) => {
    const src = isAdult ? '//cdnimg.happyshopping.kr/img_shopping/img_goods/img_no/no_adult.jpg' : `${imgPath}/200.jpg`
    const [error, setError] = useState(false)
    const [load, setLoad] = useState(false)

    const imgError = () => {
        setError(true)
    }

    const imgLoad = () => {
        setLoad(true)
    }

    return (
        <Thumb load={load}>
            {!error && (
                <img src={src} alt={alt} onError={imgError} onLoad={imgLoad} />
            )}
        </Thumb>
    )
}

const Thumb = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${noimg});
    background-size: cover;
    overflow: hidden;

    img {
        display: ${props => props.load ? 'block' : 'none'}
    }
`

export default LazyImg



// WEBPACK FOOTER //
// ./src/common/container/lazyImg.js